import Component from '../vendor/Component'

export default class ProductDescriptionMore extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  async mount() {
    this.setupListeners()
  }

  setupListeners() {
    this._elem.addEventListener('click', this.handleTriggerClick.bind(this))
  }

  handleTriggerClick() {
    // Get first visible targetElement. These are different between desktop and mobile.
    const targetElement = Array.from(document.querySelectorAll('[product-description-more-el="target"]')).find(el => el.offsetWidth > 0 && el.offsetHeight > 0);
    const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset
    const scrollToPosition = elementTop - 130

    if (targetElement) {
      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
      });

      targetElement.setAttribute('aria-expanded', 'true')

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'pdp_read_more_click'
      });
    } else {
      console.warn(`Target element "${targetSelector}" not found.`)
    }
  }
}
